import styled from 'styled-components';

interface ItemProps {
    readonly mWidth?: string;
    readonly height?: string;
    readonly backgroundColor?: string;
  }

export const EmptySpace = styled.div<ItemProps>`
  min-width: ${props => props.mWidth};
  height: ${props => props.height};
  background-color: ${props => props.backgroundColor};
`;

